import React, { Fragment, useEffect, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";

import avatar1 from '../componentes/steps/testimonials-woman.svg';
import avatar4 from '../componentes/steps/testimonials-man.svg';
import { Col, Row } from 'react-bootstrap';

const Testimonials = () => {
    const [ currentTestimonial, setCurrentTestimonial ] = useState(1);

    const testimonials = [
        { id: 1, name: 'Juan Carlos', icon: avatar4, testimonial: '"It is an application with innovative technology and with it I can store all my identity credentials safely."'},
        { id: 2, name: 'Stephania', icon: avatar1, testimonial: '"I can send and receive information with the security that everything is through the blockchain where all the procedures are stored."'},
        { id: 3, name: 'Alejandro', icon: avatar4, testimonial: '"All the elements that I have in the app are validated by a third party, so I no longer have to carry all my documents to carry out a procedure."'},
        { id: 4, name: 'Ricardo', icon: avatar4, testimonial: '"Every time I use the app they give me incentives and with the QUO\'s (incentives) I can acquire, exchange and pay many things."'}
    ]

    useEffect(() => {

    }, [])

    return (
        <Fragment id="users_testimonials">
            <Row >
                <Col md={12} className="line center mrg-bottom-20 mrgBottom" style={{marginBottom:"80px"}}>
                    <div className="x:scol-12">
                        <h2 className=" title mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60">
                            TESTIMONIALS
                        </h2>
                    </div>
                </Col>
                {
                    //(window.screen.width > 768) ?
                    <Col md={12} className="testimonial-container">
                        <Row className="line">
                            <Col md={12} className="mrg-bt-40 show-inline hide-top" style={{marginBottom:"80px"}}>
                                <Row className="hideBG line" id="divHide" regular="twins, 1024">
                                    {
                                        testimonials.map(item => {
                                            return (
                                            <Col md={3} className=" top twins" key={item.id} style={{height:"235px"}}>
                                                <AnimatePresence initial={false}>
                                                {(currentTestimonial == item.id) && (
                                                    <motion.section
                                                    key="content"
                                                    initial='open'
                                                    animate={{ opacity: 1 }}
                                                    exit={{ opacity: 0 }}
                                                    transition={{ duration: 0.2 }}
                                                    >
                                                    <p className="testimonial-content fw-bold pad-lr-0 fs-20">{item.testimonial}</p>
                                                    </motion.section>
                                                )}
                                                </AnimatePresence>
                                            </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </Col>
                            <Col md={12} className="">
                                <Row className=" line" regular="twins, 768">
                                    {
                                        testimonials.map(item => {
                                            return (
                                                <Col md={6} lg={3} className=" top testimonial-squad" key={item.id} >
                                                <div
                                                className= {`testimonials-user pad-lr-20 pad-bt-15 twins  ${currentTestimonial == item.id ? 'active' : null}` }
                                                onClick={() => setCurrentTestimonial(item.id)}
                                                onMouseEnter={() => setCurrentTestimonial(item.id)}
                                                style={{height:"114px"}}
                                                >
                                                    <Row className="line " >
                                                        <Col md={12} lg={3} className=" center left text-c-left" style={{padding:"0 5px"}}>
                                                            <img src={item.icon} style={{maxWidth: "100px", width: "100%"}}/>
                                                        </Col>
                                                        <Col lg={9} className=" center left text-c-left">
                                                            <p className="fw-semi-bold mrg-bottom-5" style={{marginBottom:"0", padding:"0px 0px"}}>{item.name}</p>
                                                            <p className="fs-14" style={{marginBottom:"0", padding:"0px 0px"}}>Dicio's user</p>
                                                            <div className="hideSM" style={{display:"none"}}>
                                                                <hr className="mrg-bt-20"/>
                                                                <p className="fw-semi-bold fs-14 fs-16">{item.testimonial}</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    
                }
            </Row>

        </Fragment>
    )
}

export default Testimonials;
